import React from 'react'
import Slider from '../Slider/Slider'

export default function AboutUs() {
  return (
    <>
       <div class="inner-page" id="about-bg">
            <div class="container">
                <div class="row">
                    <div class="col-lg-5">
                        <div class="inner_content" data-aos="fade-up" data-aos-duration="2000">
                            <h1>About Us </h1>
                            <div aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a href="#"><i class="ri-home-4-line"></i> Home</a></li>
                                    <li class="breadcrumb-item active" aria-current="page">About Us</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section class="about_sec">
            <div class="container">
                <div class="row g-4">
                    <div class="col-lg-8">
                        <div class="heading">
                            <h2>360 Digital Solutions <br/> for your needs.</h2>
                            <p>
                                Adret Software Services is one of the leading companies in the web and software development industry. We have a team of seasoned skills and creative minds who are deft at providing perfect web solutions to give you a competitive edge.
                 
                            </p>
                            <p>
                                From developing responsive websites and user-friendly mobile applications to establishing robust eCommerce platforms, our multifaceted services aim to enhance your digital footprint. Our strategic digital marketing initiatives encompass SEO, social media, and content creation to drive brand visibility, engagement, and conversions. Furthermore, our design and branding services forge impactful visual identities, fostering brand recognition and resonance


                            </p>
                            <div class="btn_sec">
                                <a href="" class="btn1">Quick Enquiry</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <img src="assets/image/about-img1.png" class="img-fluid rounded" alt=""/>
                    </div>
                </div>
            </div>
        </section>

        <section class="about_sec1 bg_color">
            <div class="container">
                <div class="row g-4 align-items-center">
                    <div class="col-lg-4">
                        <img src="assets/image/about-img2.png" class="img-fluid rounded" alt=""/>
                    </div>
                    <div class="col-lg-8">
                        <div class="heading">
                            <h2>Adret Software Services -<br/> Story Of a Leading Brand</h2>
                            <p>
                                Embrace a comprehensive suite of 360-degree digital solutions tailored to meet your diverse digital requisites. Our integrated approach spans a wide spectrum of services, encompassing web development, app creation, eCommerce solutions, digital marketing strategies, and design and branding expertise. We prioritize understanding your unique needs, ensuring each solution aligns with your specific objectives and amplifies your online presence. We're committed to delivering innovative, high-quality solutions, providing a one-stop destination for all your digital aspirations. Trust us to propel your business forward in the digital realm, enabling growth and success through our holistic and client-focused 360 digital solutions.
                            </p>
                            <div class="btn_sec">
                                <a href="" class="btn2">Drop In A Message</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="about_sec2">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="heading">
                            <h3>Website Development | Mobile App Development <br/> | Digital Marketing</h3>
                            <p>
                                Boasting significant expertise in delivering impactful web and mobile solutions, we empower our clients to expand their businesses and drive substantial revenue. Our adept professionals dedicate themselves to tailoring business solutions for your industry niche, employing comprehensive market research and competitor analysis for a customized approach.
                            </p>
                         

                        </div>
                    </div>
                </div>
                <div class="row row-below g-4">
                    <div class="col-lg-12">
                        <div class="heading">
                            <h4>Our Prime focal areas are:</h4>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="content_about d-flex align-items-center ">
                            <img src="assets/image/code.gif" class="img-fluid w-25 mr-3" alt=""/>
                            <p><a href="">Website <br/> Development</a></p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="content_about d-flex align-items-center ">
                            <img src="assets/image/ecommerce.gif" class="img-fluid w-25 mr-3" alt=""/>
                            <p><a href="">eCommerce Development</a></p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="content_about d-flex align-items-center ">
                            <img src="assets/image/mobile-development.gif" class="img-fluid w-25 mr-3" alt=""/>
                            <p><a href="">Mobile App <br/> Development</a></p>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="content_about d-flex align-items-center ">
                            <img src="assets/image/digital-marketing.gif" class="img-fluid w-25 mr-3" alt=""/>
                            <p><a href="">Digital <br/> Marketing</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Slider/>
        <section class="protfilio_sec aos-init aos-animate" data-aos="fade-up" data-aos-duration="1500">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 text-center row_gaping">
                        <div class="heading aos-init aos-animate" data-aos="fade-down" data-aos-duration="2000">
                            <h2>Our Professionals Team</h2>
                        </div>
                    </div>
                </div>
                <div class="row g-4 justify-content-center">
                    <div class="col-lg-6">
                        <div class="meet_team_con aos-init aos-animate" data-aos="zoom-in" data-aos-duration="3000">
                            <img src="assets/image/adret-software-service-office.jpg" alt="" class="img-fluid"/>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="meet_team_con aos-init aos-animate" data-aos="zoom-in" data-aos-duration="3000">
                            <img src="assets/image/adret-software-service-office-img1.jpg" alt="" class="img-fluid"/>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="meet_team_con aos-init" data-aos="zoom-in" data-aos-duration="3000">
                            <img src="assets/image/adret-software-service-office-img.jpg" alt="" class="img-fluid"/>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 text-center row-below">
                    <div class="btn_sec aos-init" data-aos="fade-down" data-aos-duration="2000">
                        <a href="" class="btn1">Meet Our Team</a>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}
